import { Permission, Resource } from '@seccl/client';

import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { useScopes } from '../../hooks/useScope';

export const CLIENT_FEE_GROUP_FEATURE_FLAG = 'seccl-12096-client-fee-group-table-ui';

export const useCanViewClientGroups = () => {
  const { hasScope } = useScopes();
  const { hasFeatureFlag } = useFeatureFlag();

  return (
    hasScope(Resource.ClientFeeGroup, Permission.ReadWrite) &&
    hasScope(Resource.ClientEnhanced, Permission.ReadWrite) &&
    hasFeatureFlag(CLIENT_FEE_GROUP_FEATURE_FLAG)
  );
};
